import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { config } from 'api';

import { scribeDocumentBase } from 'apps/scribe/ScribePropTypes';
import PromoBoxContent from './promoBoxPartials/PromoBoxContent';
import GraphicPageComponent from 'apps/analytics/components/GraphicPageComponent';
import GraphicImpression from 'apps/gtm/containers/GraphicImpression';
import impressionTypes from 'apps/gtm/utils/gtmImpressionTypes';
import FopRibbon from 'apps/fops/components/FopRibbon';
import SectionType from 'apps/catalogue/models/SectionType';
import scribeDocumentTypes from 'apps/scribe/utils/scribeDocumentTypes';

function getWebshopAnalyticsImpression(promoBox, landingPage) {
  const { docNo, docVersionNo } = promoBox;
  const { docNo: parentNo, docVersionNo: parentVersionNo } = landingPage;
  return promoBox && landingPage && (
    <GraphicPageComponent
      docNo={docNo}
      docVersionNo={docVersionNo}
      parentNo={parentNo}
      parentVersionNo={parentVersionNo}
      description="CLP_PROMOTED_BOX"
    />
  );
}

function getGoogleAnalyticsImpression(promoBox, landingPage) {
  const { docNo, docTitle, docVersionNo } = promoBox;
  const { docTitle: parentTitle, docNo: parentNo, docVersionNo: parentVersionNo } = landingPage;
  const id2 = `${docNo}-${docVersionNo}-${parentNo}-${parentVersionNo}`;

  return promoBox && landingPage && (
    <GraphicImpression
      id={docNo}
      id2={id2}
      name={docTitle}
      creative={parentTitle}
      position={impressionTypes.CLP_PROMOTED_BOX}
    />
  );
}

export default class PromoBoxInMainContainer extends PureComponent {
  static propTypes = {
    firstElement: PropTypes.shape({
      ...scribeDocumentBase,
    }).isRequired,
    secondElement: PropTypes.shape({
      ...scribeDocumentBase,
    }),
    landingPage: PropTypes.shape({
      ...scribeDocumentBase,
    }).isRequired,
    gtmPageType: PropTypes.string.isRequired,
    idx: PropTypes.number.isRequired,
    sectionLength: PropTypes.number.isRequired,
  };

  state = {
    visible: true,
  };

  componentDidMount() {
    this.mq = window.matchMedia(`(min-width: ${config.breakpoints.xlarge})`);
    this.mq.addListener(this.handleMediaQuery);
    this.handleMediaQuery(this.mq);
  }

  componentWillUnmount() {
    this.mq.removeListener(this.handleMediaQuery);
  }

  handleMediaQuery = (mq) => {
    this.setState({ visible: mq.matches });
  };

  renderElement = (element) => {
    if (!element) {
      return null;
    }

    const { gtmPageType, landingPage } = this.props;

    return (
      <Fragment>
        <PromoBoxContent
          {...element}
          gtmPageType={gtmPageType}
          parentContainer={landingPage}
          scribeDocumentType={scribeDocumentTypes.CLP_PROMOTED_BOX}
        />
        {getWebshopAnalyticsImpression(element, landingPage)}
        {getGoogleAnalyticsImpression(element, landingPage)}
      </Fragment>
    );
  }

  render() {
    const { firstElement, secondElement, idx, sectionLength } = this.props;

    if (!this.state.visible) {
      // Promo boxes are displayed only on desktop breakpoint. On any other they are hidden and
      // cause incorrect repetition of fop-ribbon title, so we hide them for proper markup and css calculation
      return null;
    }

    return (
      <li className={classNames('promotion', 'show-for-xlarge', { lastPromoBox: idx === sectionLength - 1 })}>
        <FopRibbon sectionType={SectionType.PROMO_BOX} idx={idx} sectionLength={sectionLength} />
        {this.renderElement(firstElement)}
        {this.renderElement(secondElement)}
      </li>
    );
  }
}
